import React, { Component } from "react";
import { Property } from "../../api/Property";
import { CurrencyUtil, LocaleUtil, StringUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import Strings from "@my-dld/assets/strings";
import { ImperialSystem, UnitSystem } from "@my-dld/utils/UnitUtils";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import { RVPropertyType, RVPropView } from "../../api/entities";
import I8N from "@eres/core/dist/I8N";

interface XProperty extends Property {
	isSelected?: boolean;
	index?: number;
}

export interface OPProps {
	properties?: XProperty[];
	type: RVPropertyType;
	unit: UnitSystem;
	view_type: RVPropView;
	onSelect: ( property: XProperty, action?: string ) => void;
}

class RVPropertyTable extends Component<OPProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	configDataTable = () => {
		const { type } = this.props;
		try {
			window.$( "#my-prop-table-" + type ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: true,
				lengthChange: false
			} );
			const openDetails = this.openDetails;
			window.$( "#my-prop-table-" + type ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				// @ts-ignore
				let id = this.getAttribute( "id" );
				if ( item ) {
					if ( id === "details" ) {
						openDetails( item, "view_detail" );
					}
				}

				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};

	openDetails = ( property: Property, action?: string ) => {
		this.props.onSelect( property, action );
	};

	render() {
		const { properties, type, view_type } = this.props;
		if ( properties == null || properties.length < 1 ) {
			return null;
		}
		let Header = <LandHeader view_type={ view_type }/>;
		let Row = LandRow;
		switch ( type ) {
			case RVPropertyType.VILLA:
			case RVPropertyType.BUILDING:
				Header = <VillaHeader view_type={ view_type }/>;
				Row = VillaRow;
				break;
			case RVPropertyType.UNIT:
				Header = <UnitHeader view_type={ view_type }/>;
				Row = UnitRow;
				break;
		}
		return <ListDataView
			id={ "my-prop-table-" + type }
			title={ `${ getOPLabel( type ) } (${ properties!.length })` }
			items={ properties ? properties : [] }
			renderListHeader={ () => Header }
			renderListItem={ ( value: Property ) => {
				return <Row
					key={ value.PropertyId }
					isSqFt={ this.props.unit.Id === ImperialSystem.Id }
					property={ value }
					view_type={ view_type }
					onDetails={ this.openDetails }/>;
			} }/>;
	}
}

export function getOPLabel( t: RVPropertyType ) {
	switch ( t ) {
		case RVPropertyType.LAND:
			return Strings.land_label;
		case RVPropertyType.VILLA:
			return Strings.villa;
		case RVPropertyType.UNIT:
			return Strings.unit;
		case RVPropertyType.BUILDING:
			return Strings.villa;
	}
}

interface RowProps {
	property: XProperty;
	onDetails: ( p: XProperty, action?: string ) => void;
	isSqFt: boolean;
	view_type: RVPropView;
}

function TD( props: { value?: string, className?: string, onClick?: () => void } ) {
	let { value, className } = props;
	if ( value == null || StringUtil.isEmptyStringOrNull( value ) )
		value = "-";
	return <td
		className={ className } onClick={ e => {
		e.preventDefault();
		if ( props.onClick ) props.onClick();
	} }>{ value }</td>;
}

function LH( props: { hideLand?: boolean, rentalRange?: string | undefined, view_type: RVPropView } ) {
	const { hideLand, view_type } = props;
	return <React.Fragment>
		{
			!hideLand && <th>{ Strings.land_num_label }</th>
		}
		<th>{ Strings.area_label }</th>
		<th>{ Strings.size }</th>
		{
			view_type !== RVPropView.RV_REQ_Properties &&
			<React.Fragment>
				<th>{ Strings.rental_index }</th>
				<th>{ "" }</th>
			</React.Fragment>
		}
		{
			view_type === RVPropView.RV_REQ_Properties &&
			<React.Fragment>
				<th>{ Strings.completion_date }</th>
				<th>{ Strings.usage }</th>
				<th>{ Strings.type }</th>
			</React.Fragment>
		}
	</React.Fragment>;
}

function LR( props: RowProps & { xClass?: string, hideLand?: boolean, rentalRange?: string | undefined } ) {
	const { property, hideLand, rentalRange, onDetails, view_type } = props;
	let { xClass } = props;
	const isSelected = property.isSelected ? "far fa-check-circle" : "far fa-check-circle";
	const isDataCompleted = ( property.rvData && property.rvData.isDataCompleted ) ? "far fa-check-circle" : "fa fa-info-circle text-warning";

	const pType = property.PropertyTypeId;
	const hasType = pType !== RVPropertyType.LAND ? LocaleUtil.getLocalValue( { en: property.EjariTypeNameEn, ar: property.EjariTypeNameAr } ) : "";
	const hasSubType = pType === RVPropertyType.UNIT || pType === RVPropertyType.VILLA ?
		LocaleUtil.getLocalValue( { en: property.EjariSubTypeNameEn, ar: property.EjariSubTypeNameAr } ) : "";
	return <React.Fragment>
		{
			!hideLand && <TD
				className={ "prop-mun-no " + ( xClass ? xClass : "" ) } value={ getOPMunNo( property ) } onClick={ () => {
				props.onDetails( props.property );
			} }/>
		}
		{/*<TD className="prop-land-no" value={ property.landNo }/>*/ }
		<TD className="prop-area" value={ LocaleUtil.getLocalValue( { en: property.AreaEn, ar: property.AreaAr } ) }/>
		<TD className="size" value={ getOPSize( property ) }/>
		{
			view_type === RVPropView.Tabu_Properties &&
			<React.Fragment>
				<TD className="size" value={ rentalRange }/>
				<td className="td-action">
					<button
						className="btn btn-sm" onClick={ () => {
						onDetails( props.property );
					} }>
						<i className={ isSelected }/>
					</button>
				</td>
			</React.Fragment>
		}
		{
			view_type === RVPropView.RV_Properties &&
			<React.Fragment>
				<TD className="size" value={ rentalRange }/>
				<td className="td-action">
					<button
						className="btn btn-sm" onClick={ () => {
						onDetails( props.property, "view_detail" );
					} }>
						<i className={ isDataCompleted }/>
					</button>
					<button
						className="btn btn-sm" onClick={ () => {
						onDetails( props.property, "delete" );
					} }>
						<i className="fa fa-trash-alt"/>
					</button>
				</td>
			</React.Fragment>
		}
		{
			view_type === RVPropView.RV_REQ_Properties &&
			<React.Fragment>
				<td>{ property.PropertyCompletionDate!.asDate().asSimpleDateString() }</td>
				<td>{ LocaleUtil.getLocalValue( { en: property.EjariUsageNameEn, ar: property.EjariUsageNameAr } ) }</td>
				<td>{ hasType + " - " + hasSubType }</td>
			</React.Fragment>
		}
	</React.Fragment>;
}

function LandRow( props: RowProps ) {
	let data = props.property;
	const rentalAvailable = ( data.RentalIndexMin != undefined && data.RentalIndexMax != undefined && data.RentalIndexMin !== 0 && data.RentalIndexMax !== 0 );
	let rentalRange: string | undefined = undefined;
	if ( rentalAvailable ) {
		const max = DisplayCurrency( data.RentalIndexMax );
		const min = DisplayCurrency( data.RentalIndexMin );
		rentalRange = min + " - " + max;
	}
	const selectedTR = ( props.view_type === RVPropView.Tabu_Properties && data.isSelected ) ? "selectedTR" : undefined;
	return <tr className={ selectedTR }>
		<LR { ...props } xClass={ "underline" } rentalRange={ rentalRange }/>
	</tr>;
}

function LandHeader( props?: { view_type: RVPropView } ) {
	const { view_type } = props!;
	return <tr>
		<LH view_type={ view_type }/>
	</tr>;
}

function VillaHeader( props?: { view_type: RVPropView } ) {
	const { view_type } = props!;
	return <tr>
		<th>{ Strings.name }</th>
		<LH view_type={ view_type }/>
	</tr>;
}

function VillaRow( props: RowProps ) {
	let property = props.property;
	let val = property.PropertyNumber;
	const selectedTR = ( props.view_type === RVPropView.Tabu_Properties && property.isSelected ) ? "selectedTR" : undefined;
	return <tr className={ selectedTR }>
		<TD
			className="prop-vil-no underline cur-hand" value={ val }
			onClick={ () => {
				props.onDetails( props.property );
			} }/>
		<LR { ...props }/>
	</tr>;
}

function UnitHeader( props?: { view_type: RVPropView } ) {
	const { view_type } = props!;
	return <tr>
		<th>{ Strings.Unit_Number_Label }</th>
		<th>{ Strings.building_name }</th>
		<LH hideLand={ true } view_type={ view_type }/>
	</tr>;
}

function UnitRow( props: RowProps ) {
	let property = props.property;
	let val = property.UnitNo;
	const selectedTR = ( props.view_type === RVPropView.Tabu_Properties && property.isSelected ) ? "selectedTR" : undefined;
	return <tr className={ selectedTR }>
		<TD
			className="prop-unit-no underline  cur-hand" value={ val }
			onClick={ () => {
				props.onDetails( props.property );
			} }/>
		<TD className={ "prop-b-name" } value={ LocaleUtil.getLocalValue( { en: property.BuildingNameEn, ar: property.BuildingNameAr } ) }/>
		<LR { ...props } hideLand={ true }/>
	</tr>;
}

export function getOPMunNo( property: XProperty ) {
	if ( property.LandNo && property.LandNo !== "0" ) {
		let ln = property.LandNo;
		if ( property.LandSubNo && property.LandSubNo !== "0" ) {
			ln = ln + "-" + property.LandSubNo;
		}
		return ln;
	}
	return "";
}

export function getOPSize( property: XProperty ) {
	return property.Size + "";
}

export function DisplayCurrency( value: number, withAed: boolean = false ) {
	if ( value && value !== 0 ) {
		let v = CurrencyUtil.toSimpleCurrency( value );
		if ( withAed ) {
			if ( I8N.isRTL() ) {
				v = "\u200e\u200f" + Strings.AED + " \u200e" + v;
			} else {
				v = v + " " + Strings.AED;
			}
		}
		return v;
	}
	return "-";
}

export default RVPropertyTable;
